import React, { Component } from "react";

import './StubPage.css';

class StubPage extends Component {
	render() {
		return (
			<div className="stub-content">
				{/*<div className="content " >*/}
					<div  className="main-stub-title"> 
						<big><big><big><big>Скоро здесь будет статистика<br />по Вашим пользователям</big></big></big></big>
					</div>
					
				{/*</div>*/}
			</div>
		)
	}
}

export default StubPage;



// WEBPACK FOOTER //
// ./src/views/Stub/StubPage.jsx